module.exports = __webpack_public_path__ + "static/media/PoppinsBold.453e546d.eot";